(function () {
  var ZIPPPLY_CHECKOUT_URL = window.ZipplyCheckoutUrl || 'https://content-alignment-production-d418.up.railway.app/checkout';

  function isCheckoutButton(element) {
    if (!element) return false;

    var text = (element.innerText || element.value || '').toLowerCase();
    var name = (element.getAttribute('name') || '').toLowerCase();
    var id = (element.getAttribute('id') || '').toLowerCase();
    var classes = (element.className || '').toString().toLowerCase();

    return (
      name === 'checkout' ||
      id === 'checkout' ||
      classes.indexOf('checkout') > -1 ||
      text.indexOf('checkout') > -1 ||
      text.indexOf('proceed') > -1
    );
  }

  function isZipplyBuyNowButton(element) {
    if (!element) return false;
    var classes = (element.className || '').toString().toLowerCase();
    var text = (element.innerText || element.value || '').toLowerCase();
    return classes.indexOf('zipply-buy-now-button') > -1 || text.indexOf('buy it now') > -1;
  }

  function buildCheckoutUrl(cart) {
    var payload = {
      shop: window.Shopify && window.Shopify.shop ? window.Shopify.shop : window.location.hostname,
      currency: cart.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR',
      token: cart.token,
      item_count: cart.item_count || 0,
      total_price: cart.total_price || 0,
      original_total_price: cart.original_total_price || cart.total_price || 0,
      total_discount: cart.total_discount || 0,
      cart_level_discount_applications: cart.cart_level_discount_applications || [],
      items: (cart.items || []).map(function (item) {
        return {
          key: item.key,
          variant_id: item.variant_id,
          product_id: item.product_id,
          quantity: item.quantity,
          title: item.product_title || item.title,
          product_title: item.product_title,
          variant_title: item.variant_title,
          sku: item.sku,
          vendor: item.vendor,
          handle: item.handle,
          url: item.url,
          image: item.image,
          price: item.price,
          original_price: item.original_price,
          final_price: item.final_price,
          line_price: item.line_price,
          original_line_price: item.original_line_price,
          final_line_price: item.final_line_price,
          discounts: item.discounts || [],
          properties: item.properties || {}
        };
      })
    };

    var encodedCart = encodeURIComponent(JSON.stringify(payload));
    return ZIPPPLY_CHECKOUT_URL + '?cart=' + encodedCart + '&shop=' + encodeURIComponent(payload.shop);
  }

  async function fetchCartAndRedirect(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }

    try {
      var response = await fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });

      var cart = await response.json();

      if (!cart || !cart.item_count) {
        window.location.href = '/cart';
        return;
      }

      window.location.href = buildCheckoutUrl(cart);
    } catch (error) {
      console.error('Zipply checkout redirect failed:', error);
      window.location.href = '/checkout';
    }
  }

  function getProductHandle(button, form) {
    var handle = button && button.getAttribute('data-product-handle');
    if (handle) return handle;

    var canonical = document.querySelector('link[rel="canonical"]');
    var url = canonical ? canonical.getAttribute('href') : window.location.pathname;
    var match = url && url.match(/\/products\/([^/?#]+)/);
    if (match && match[1]) return match[1];

    var productLink = form && form.querySelector('a[href*="/products/"]');
    var href = productLink && productLink.getAttribute('href');
    var linkMatch = href && href.match(/\/products\/([^/?#]+)/);
    return linkMatch && linkMatch[1] ? linkMatch[1] : '';
  }

  async function fetchProductByHandle(handle) {
    if (!handle) return null;
    var response = await fetch('/products/' + handle + '.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) return null;
    return response.json();
  }

  function buildBuyNowItem(product, variant, variantId, quantity) {
    var price = variant && typeof variant.price === 'number' ? variant.price : 0;
    var image = '';

    if (variant && variant.featured_image && variant.featured_image.src) {
      image = variant.featured_image.src;
    } else if (product && product.featured_image) {
      image = product.featured_image;
    } else if (product && product.images && product.images.length) {
      image = product.images[0];
    }

    return {
      key: String(variantId),
      variant_id: Number(variantId),
      product_id: product && product.id ? product.id : null,
      quantity: quantity,
      title: product && product.title ? product.title : 'Selected product',
      product_title: product && product.title ? product.title : 'Selected product',
      variant_title: variant && variant.title !== 'Default Title' ? variant.title : null,
      sku: variant && variant.sku ? variant.sku : '',
      vendor: product && product.vendor ? product.vendor : '',
      handle: product && product.handle ? product.handle : getProductHandle(document.querySelector('.zipply-buy-now-button'), null),
      url: product && product.handle ? '/products/' + product.handle + '?variant=' + variantId : window.location.pathname + '?variant=' + variantId,
      image: image,
      price: price,
      original_price: price,
      final_price: price,
      line_price: price * quantity,
      original_line_price: price * quantity,
      final_line_price: price * quantity,
      discounts: [],
      properties: {}
    };
  }

  async function addProductThenRedirect(button, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }

    try {
      var form = button.closest('form[action*="/cart/add"], form[data-type="add-to-cart-form"], form');
      if (!form) {
        throw new Error('Unable to read selected product form');
      }

      var formData = new FormData(form);
      var variantId = formData.get('id');
      var quantityInput = form.querySelector('[name="quantity"]');
      var quantity = Number(formData.get('quantity') || (quantityInput && quantityInput.value) || 1);

      if (!variantId) {
        throw new Error('Please select a product variant');
      }

      if (!quantity || quantity < 1) {
        quantity = 1;
      }

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Redirecting...';

      var handle = getProductHandle(button, form);
      var product = await fetchProductByHandle(handle);
      var variant = product && product.variants ? product.variants.find(function (item) {
        return String(item.id) === String(variantId);
      }) : null;

      if (!product || !variant) {
        throw new Error('Unable to read selected product data');
      }

      var selectedItem = buildBuyNowItem(product, variant, variantId, quantity);
      var selectedCart = {
        shop: window.Shopify && window.Shopify.shop ? window.Shopify.shop : window.location.hostname,
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR',
        token: null,
        item_count: quantity,
        total_price: selectedItem.final_line_price,
        original_total_price: selectedItem.original_line_price,
        total_discount: 0,
        cart_level_discount_applications: [],
        items: [selectedItem]
      };

      window.location.href = buildCheckoutUrl(selectedCart) + '&source=buy_now';
    } catch (error) {
      console.error('Zipply buy now redirect failed:', error);
      alert(error.message || 'Unable to continue. Please try again.');
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = 'Buy it now';
      }
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('button, input[type="submit"], a');
      if (!button) return;

      if (isZipplyBuyNowButton(button)) {
        addProductThenRedirect(button, event);
        return;
      }

      if (isCheckoutButton(button)) {
        fetchCartAndRedirect(event);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form) return;

      var checkoutInput = form.querySelector('[name="checkout"], #checkout, .cart__checkout-button');
      if (checkoutInput) {
        fetchCartAndRedirect(event);
      }
    },
    true
  );
})();
